<template>
    <div id="profile">
        <div class="d-flex flex-column">
            <top-area></top-area>

            <div class="container">
                
                <ul class="nav nav-pills mb-3 profile-nav text-center d-flex flex-row flex-nowrap justify-content-center align-items-center pt-5" id="pills-tab" role="tablist">
                    <li class="nav-item mr-2 mr-lg-3">
                        <a class="nav-link active" id="pills-brush-tab" data-toggle="pill" href="#pills-brush" role="tab"
                           aria-controls="pills-brush" aria-selected="true">Periajul zilnic</a>
                    </li>
                    <li class="nav-item mx-2 mx-lg-3">
                        <a class="nav-link" id="pills-leaderboard-tab" data-toggle="pill" href="#pills-leaderboard" role="tab"
                           aria-controls="pills-leaderboard" aria-selected="false">Clasament</a>
                    </li>
                    <li class="nav-item ml-2 ml-lg-3">
                        <a class="nav-link" id="pills-calendar-tab" data-toggle="pill" href="#pills-calendar" role="tab"
                           aria-controls="pills-calendar" aria-selected="false">calendar
                            Vizite</a>
                    </li>
                </ul>
                
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-brush" role="tabpanel" aria-labelledby="pills-brush-tab">
                        <daily-brush></daily-brush>
                    </div>
                    <div class="tab-pane fade" id="pills-leaderboard" role="tabpanel" aria-labelledby="pills-leaderboard-tab">
                        <leaderboard></leaderboard>
                    </div>
                    <div class="tab-pane fade" id="pills-calendar" role="tabpanel" aria-labelledby="pills-calendar-tab">
                        <visits-calendar></visits-calendar>
                    </div>
                </div>
                
            </div>

            <facts></facts>
        </div>
    </div>
</template>

<script>
    import TopArea from './profile/TopArea'
    import DailyBrush from './profile/DailyBrush'
    import Leaderboard from './profile/Leaderboard'
    import VisitsCalendar from './profile/VisitsCalendar'
    import Facts from './profile/Facts'

    export default {
        name: "Profile",
        components: {
            TopArea,
            DailyBrush,
            Leaderboard,
            VisitsCalendar,
            Facts
        },
        mounted() {
            if (!this.$cookie.get('access-token')) {
                this.$router.push('/');
            }

            window.scrollTo(0, 0);

        }
    }
</script>

<style lang="scss">
    @import "../styles/profile.scss";
    @import "../styles/animations.scss";
</style>